interface PortalActivityIdentity {
  intendedContactName?: string
  intendedRecipientEmail?: string
  visitorId: string
}

export function portalActivityHeadline(activity: PortalActivityIdentity): string {
  const intendedRecipient = activity.intendedContactName || activity.intendedRecipientEmail
  if (intendedRecipient) {
    return `Link for ${intendedRecipient} opened`
  }
  return `Browser ${activity.visitorId.slice(0, 8)} opened`
}
